<template>
  <section class="accordion">
    <kf-accordion-filters
      :faq-categories="faqCategories"
      :current-index="currentIndex"
      @clicked="onClickChild"
    />

    <div class="accordion__wrapper">
      <transition-group
        name="fade-switch"
        tag="div"
        mode="out-in"
      >
        <kf-accordion-item
          v-for="item in activeFaqs"
          :id="item.key"
          :key="item.key"
          :title="item.question"
          :is-initially-open="item.key === preselectedItemKey"
        >
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="item.answer" />
        </kf-accordion-item>
      </transition-group>
    </div>
  </section>
</template>

<script>
import KfAccordionFilters from '@/components/accordion/AccordionFilters.vue';
import KfAccordionItem from '@/components/accordion/AccordionItem.vue';
import Utils from '@/lib/utils';

export default {
  name: 'WelcomeFaqAccordion',
  components: {
    KfAccordionItem,
    KfAccordionFilters,
  },
  props: {
    accordionItems: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      currentIndex: 0,
      preselectedItemKey: Utils.queryString.getParameter('selected'),
    };
  },
  computed: {
    faqCategories() {
      let result = [];
      for (let i = 0; i < this.accordionItems.length; i++) {
        result.push(this.accordionItems[i].name);
      }
      return result;
    },
    activeFaqs() {
      return this.accordionItems[this.currentIndex]?.frequentlyAskedQuestions || [];
    },
  },
  mounted() {
    if (
      this.preselectedItemKey &&
      typeof window !== 'undefined' &&
      typeof document !== 'undefined'
    ) {
      const $el = document.getElementById(this.preselectedItemKey);
      if ($el) {
        $el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  methods: {
    onClickChild(value) {
      return (this.currentIndex = value);
    },
  },
};
</script>
